import { URLS } from '../../../constants';
import apiClient from '../../client';

const InvoiceGridService = {
  InvoiceGridServiceApi: ({
    heading,
    roleId,
    type,
    assignedTo,
    pagination,
    order,
    name,
    serachValue,
    searchKey,
    filterValue,
  }: {
    heading: string;
    roleId: string;
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: any;
    serachValue?: any;
    searchKey?: any;
    filterType?: any;
    subType?: any;
  }) => {
    let otherFilterData = [];
    if (serachValue) {
      otherFilterData.push({
        filterKey: searchKey || '',
        filterValue: serachValue ? serachValue : '',
      });
    }
    if (typeof filterValue !== 'string') {
      otherFilterData = [...otherFilterData];
    } else if (typeof filterValue === 'string' && filterValue.length > 0) {
      otherFilterData.push({
        filterKey: '',
        filterValue: serachValue ? serachValue : '',
      });
    }
    return apiClient.post(URLS.getInvoiceGridData, {
      data: {
        heading,
        roleId,
        type,
        pagination,
        assignedTo,
        filter: typeof filterValue !== 'string' ? filterValue : [],
        otherFilterData,
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'modifiedDate',
        },
      },
    });
  },

  InvoiceDeletetedGridServiceApi: ({
    heading,
    roleId,
    type,
    assignedTo,
    pagination,
    order,
    name,
    serachValue,
    searchKey,
    filterValue,
  }: {
    heading: string;
    roleId: string;
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: any;
    serachValue?: any;
    searchKey?: any;
    filterType?: any;
    subType?: any;
  }) => {
    let otherFilterData = [];
    if (serachValue) {
      otherFilterData.push({
        filterKey: searchKey || '',
        filterValue: serachValue ? serachValue : '',
      });
    }
    if (typeof filterValue !== 'string') {
      otherFilterData = [...otherFilterData];
    } else if (typeof filterValue === 'string' && filterValue.length > 0) {
      otherFilterData.push({
        filterKey: '',
        filterValue: serachValue ? serachValue : '',
      });
    }
    return apiClient.post(URLS.getDeletedInvoice, {
      data: {
        heading,
        roleId,
        type,
        pagination,
        assignedTo,
        filter: typeof filterValue !== 'string' ? filterValue : [],
        otherFilterData,
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'modifiedDate',
        },
      },
    });
  },
  deleteInvoice: ({ invoiceId }: { invoiceId: any }) =>
    apiClient.post(URLS.deleteInvoice, {
      data: {
        id: invoiceId,
      },
    }),
};

export default InvoiceGridService;
